export default "__VITE_ASSET__DFnaHM$c__"